module.exports = __webpack_public_path__ + "img/poles-DE.64a3c95e.png";